import React, { useState } from "react";
import PersonalInfo from "./about/PersonalInfo";
import Programming from "./about/Programming";
import ServiceSection from "./about/ServiceSection";
import EduAndExp from "./about/EduAndExp";
import Interest from "./about/Interest";
import Footer from "./Footer";
import WeekendModeContent from "./common/WeekendModeContent";
import ProfilePortrait from "./common/ProfilePortrait";
import WeekendPortrait from "./common/WeekendPortrait";
import SocialIcon from "./common/SocialIcon";
import MenuSocialIcons from "./common/MenuSocialIcons";
import SiteLogo from "./common/SiteLogo";
import { Link } from "react-router-dom";

const profileImage = `${process.env.PUBLIC_URL}/haseeb.png`;

const About = () =>
{
  const [isBurgerClicked, setIsBurgerClicked] = useState(false);

  const handleBurgerClick = () => {
    setIsBurgerClicked((prevClicked) => !prevClicked);
  };
  return (
    <>
      <div className="salva-page-wrap">
        <section
          className="salva-fixed-content salvadark-section"
          id="about_us"
        >
          <div className="container-fluid">
            <div className="row home-content-row">
              {/* <!--Left side salva fixed image start here--> */}
              <div className="col-12 col-md-5 col-lg-4 col-xxl-5 salva-left-fixed-image p-0">
                <h1 className="d-none">this is a image of salva fixed</h1>
                <ProfilePortrait />
                <WeekendPortrait />
              </div>
              {/* <!--Left side salva fixed image end here --> */}
              {/* <!--right side salva content start here--> */}
              <div className="col-12 col-md-12 col-lg-8 col-xxl-7 salva-home-content salv-about-dark-content dark-home-content p-0">
                <div
                  className={`salva-about-wrap ${
                    isBurgerClicked ? "border-none" : ""
                  }`}
                >
                  {/* <!--header content start here --> */}
                  <header className="salva-header salv-home-header salv-dark-header">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-6 col-sm-6 col-md-4 col-lg-4">
                          <a className="salva-logo" href="/">
                            <SiteLogo />
                          </a>
                        </div>
                        <div className="col-6 col-sm-6 col-md-8 col-lg-8">
                          <nav className="navbar salva-header-nav dark-salv-header">
                            <div className="d-flex">
                              <input
                                type="checkbox"
                                id="navcheck"
                                className="navcheck"
                                role="button"
                                title="menu"
                                aria-pressed="true"
                              />
                              <label
                                htmlFor="navcheck"
                                aria-hidden="true"
                                title="menu"
                              >
                                <span
                                  className={`salv-burger dark-salv-burger ${
                                    isBurgerClicked ? "click" : ""
                                  }`}
                                  onClick={handleBurgerClick}
                                >
                                  <span className="bar dark-bar">
                                    <span className="visuallyhidden">Menu</span>
                                  </span>
                                </span>
                              </label>
                              {/* <!--desktop screen menu design --> */}
                              <ul
                                id="menu"
                                className="sal-menu-list dark-sal-menu-list"
                              >
                                <li className="salv-menu-item">
                                  <Link
                                    to="/"
                                    target="_self"
                                    className="salv-menu-link dark-color"
                                  >
                                    Home
                                  </Link>
                                </li>
                                <li className="salv-menu-item">
                                  <Link
                                    to="/about"
                                    target="_self"
                                    className="w-text salv-menu-link dark-menu-link active"
                                  >
                                    About
                                  </Link>
                                </li>
                                <li className="salv-menu-item">
                                  <Link
                                    to="/portfolio"
                                    target="_self"
                                    className="salv-menu-link dark-color"
                                  >
                                    Portfolio
                                  </Link>
                                </li>
                                <li className="salv-menu-item">
                                  <Link
                                    to="/contact"
                                    target="_self"
                                    className="salv-menu-link dark-color"
                                  >
                                    Contact
                                  </Link>
                                </li>
                              </ul>
                              {/* <!--tablet screen menu design --> */}
                              <div className="salv-menu-design-two">
                                <div className="menu-design-wrap">
                                  <div className="salv-menu-profile">
                                    <img
                                      src={profileImage}
                                      alt="Haseeb Sajjad profile"
                                    />
                                  </div>
                                  <div className="sakv-new-menu-social">
                                    <MenuSocialIcons />
                                  </div>
                                  <div className="salv-menu-list">
                                    <ul className="salv-sec-menu-item">
                                      <li className="salv-sec-menu-link">
                                        <Link
                                          to="/"
                                          className="slav-tb-menu-name"
                                          target="_self"
                                        >
                                          home
                                        </Link>
                                      </li>
                                      <li className="salv-sec-menu-link">
                                        <Link
                                          to="/about"
                                          target="_self"
                                          className="slav-tb-menu-name active"
                                        >
                                          about
                                        </Link>
                                      </li>
                                      <li className="salv-sec-menu-link">
                                        <Link
                                          to="/portfolio"
                                          target="_self"
                                          className="slav-tb-menu-name"
                                        >
                                          portfolio
                                        </Link>
                                      </li>
                                      <li className="salv-sec-menu-link">
                                        <Link
                                          to="/contact"
                                          target="_self"
                                          className="slav-tb-menu-name"
                                        >
                                          contact
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                  <div className="salv-mob-copyright">
                                    <p className="salv-copyright-content mb-0 sm-font inter-font-400 b-text light-copyright">
                                      Copyright © 2023 Salva ❤{" "}
                                      <Link
                                        to="https://1.envato.market/website-portfolio"
                                        className="w-text"
                                        target="_blank"
                                      >
                                        the_krishna
                                      </Link>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </nav>
                        </div>
                      </div>
                    </div>
                  </header>

                  {/* <!--Salva About Content start --> */}
                  <div className="salva-about-content dark-about-content weekend-mode-hide">
                    <div className="salv-inrto-content">
                      <h2
                        className="salv-about-title salv-home-title md-font w-text inter-font-900 mb-0"
                        data-aos="flip-left"
                        data-aos-easing="ease-out-cubic"
                        data-aos-duration="2000"
                      >
                        About
                      </h2>
                      <div className="sec-text text-anim">
                        <p
                          className="salv-about-desc mb-0 dark-sec-color inter-font-400"
                          data-aos="fade-right"
                          data-aos-offset="300"
                          data-aos-easing="ease-in-sine"
                        >
                          I am a Full Stack Developer with over three years of
                          hands on experience in web development and software
                          engineering. I have built React apps, backend APIs,
                          WordPress sites, third party integrations, and
                          business platforms like LMS, HRMS, CRM, and chat
                          systems. I enjoy solving real business problems and
                          creating practical, maintainable software. I have
                          worked with remote teams and clients in the UK and
                          UAE. My goal is to keep building quality software
                          with better performance, automation, and user
                          experience.
                        </p>
                      </div>
                    </div>
                    {/* <!--About personal info --> */}
                    <PersonalInfo />

                    {/* <!--About programming and language --> */}
                    <Programming />

                    {/* <!--About Service section here --> */}
                    <ServiceSection />

                    {/* <!--About eduction and experienced --> */}
                    <EduAndExp />

                    {/* <!--About interest section --> */}
                    <Interest />
                  </div>
                  {/* <!--weekend-mode start here--> */}
                  <WeekendModeContent />
                  {/* <!--social icon start here --> */}
                  <SocialIcon />
                  {/* <!--footer content start here --> */}
                  <Footer />
                </div>
              </div>
              {/* <!--right side salva content end here --> */}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
export default About;
